import { TableSearch } from "ui/components/Table/TableSearch";
import { memo } from "react";
import { initialDataWithPagination } from "services/api/consts";
import {
  CONTACT_SEARCH_COLUMNS,
  CONTACT_REPRESENTATIVE_CHILD_COLUMNS,
} from "./consts";
import { ContactSearchResultsProps } from "./types";
import { useTranslate } from "helpers";
import ContactRepresentativeRowChild from "./components/ContactRepresentativeRowChild";

const ContactSearchResults: React.FC<ContactSearchResultsProps> = (props) => {
  const {
    searchResults,
    selectedRows,
    isLoading,
    onRowClick,
    onPaginationChange,
    onSelectedChange,
    onDeleteClick,
    onEmailClick, 
    onPhoneClick,
    onGoogleMapClick
  } = props;

  const { t } = useTranslate();
  return (
    <>
      <TableSearch
        columns={CONTACT_SEARCH_COLUMNS(t, onDeleteClick, onEmailClick, onPhoneClick, onGoogleMapClick)}
        columnsChild={CONTACT_REPRESENTATIVE_CHILD_COLUMNS(t)}
        CustomTableRowChild={ContactRepresentativeRowChild}
        childTableTitle="Povezane osobe"
        data={searchResults.data}
        selectedRows={selectedRows}
        pagination={
          searchResults.pagination || initialDataWithPagination.pagination
        }
        selectableRows={false}
        onPaginationChange={onPaginationChange}
        onSelectedChange={onSelectedChange}
        isLoading={isLoading}
        onRowClick={onRowClick}
        size="full"
      />
    </>
  );
};
export default memo(ContactSearchResults);
